/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Filter_All_RolesInputs */



/**
* | output |
* | --- |
* | "All roles" |
*
* @param {Team_Manager_Filter_All_RolesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_filter_all_roles = /** @type {((inputs?: Team_Manager_Filter_All_RolesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Filter_All_RolesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tous les rôles")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Rollen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutti i ruoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Все роли")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos los roles")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所有角色")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべての役割")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी भूमिकाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Todas as funções")
	return /** @type {LocalizedString} */ ("All roles")
});